import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { API_BASE_URL } from "../../../config";
import { useNavigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import {
  fetchNotifications,
  setLastSentNotice,
} from "../../../redux/slices/notifications";

const AvvisiContext = createContext();

export const useAvvisi = () => {
  const context = useContext(AvvisiContext);
  if (!context) {
    throw new Error("useAvvisi must be used within an AvvisiProvider");
  }
  return context;
};

export const AvvisiProvider = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Connect to global Redux state
  const {
    items: avvisiList,
    loading,
    error,
    fetched,
  } = useSelector((state) => state.notifications);

  const fetchAvvisi = useCallback(async () => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    // Only fetch if not yet fetched, not currently loading, and we HAVE a token
    if (!fetched && !loading && token) {
      fetchAvvisi();
    }
  }, [fetchAvvisi, fetched, loading]);

  const addAvviso = useCallback(
    async (newAvvisoData) => {
      const token = sessionStorage.getItem("token");
      if (!token) return;
      try {
        // Build the request body
        const requestBody = {
          data: {
            titolo: newAvvisoData.titolo || "titolo",
            descrizione: newAvvisoData.descrizione || "descrizione avviso",
            dataScadenza: newAvvisoData.expirationDate || "16/01/2026",
            hasLike: newAvvisoData.allowLikes ? 1 : 0,
            hasComment: newAvvisoData.allowComments ? 1 : 0,
            hasPopup: newAvvisoData.showPopup ? 1 : 0,
            idTipologia:
              newAvvisoData.tipo === "urgent"
                ? "2"
                : newAvvisoData.tipo === "task"
                ? "3"
                : "1",
            userList: newAvvisoData.targetUsers,
            dataScadenza: newAvvisoData.expirationDate,
          },
        };

        // Add targetUserId if specified (for Socket.IO targeted messaging)
        if (newAvvisoData.targetUserId && newAvvisoData.targetUserId.trim()) {
          requestBody.targetUserId = newAvvisoData.targetUserId.trim();
        }

        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + token,
          },
          body: JSON.stringify(requestBody),
        };

        const response = await fetch(
          `${API_BASE_URL}/api/avvisiSave`,
          requestOptions
        );

        if (!response.ok) {
          throw new Error("Failed to save avviso");
        }
        const result = await response.json();

        // Refresh the list after successful save
        await fetchAvvisi();

        return result;
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    [fetchAvvisi]
  );

  const markAsRead = (avvisoId) => {
    console.log("Mark as read", avvisoId);
  };

  const toggleLike = (avvisoId) => {
    console.log("Toggle like", avvisoId);
  };

  const addComment = (avvisoId, text) => {
    console.log("Add comment", avvisoId, text);
  };

  const value = {
    avvisiList,
    loading,
    error,
    fetchAvvisi,
    addAvviso,
    markAsRead,
    toggleLike,
    addComment,
  };

  return (
    <AvvisiContext.Provider value={value}>{children}</AvvisiContext.Provider>
  );
};
